import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faMobile } from '@fortawesome/free-solid-svg-icons';
import '../styles/ProfileAppModal.css';

const ProfileAppModal = ({ isOpen, onClose, type = 'profile' }) => {
  if (!isOpen) return null;

  // Different content based on type
  const content = {
    profile: {
      title: 'Access Your Profile',
      message: 'Your profile and settings are available in the Yesod mobile app. Download or open the app to access your complete profile.',
      deepLink: 'yesod://profile'
    },
    join: {
      title: 'Join Community',
      message: 'Requesting to join communities is available in the Yesod mobile app. Download or open the app to submit your join request.',
      deepLink: 'yesod://groups'
    }
  };

  const currentContent = content[type] || content.profile;

  const handleOpenApp = () => {
    // Try to open the app with a deep link first
    const appDeepLink = currentContent.deepLink;
    const appStoreLink = 'https://apps.apple.com/us/app/yesod/id6748472269';
    
    // Create a hidden link to attempt deep linking
    const link = document.createElement('a');
    link.href = appDeepLink;
    link.style.display = 'none';
    document.body.appendChild(link);
    
    // Try to open the app
    link.click();
    document.body.removeChild(link);
    
    // Fallback to App Store after a short delay if app doesn't open
    setTimeout(() => {
      window.open(appStoreLink, '_blank');
    }, 500);
    
    onClose();
  };

  return (
    <div className="profile-app-modal-overlay" onClick={onClose}>
      <div className="profile-app-modal" onClick={(e) => e.stopPropagation()}>
        <div className="profile-app-modal-header">
          <h2 className="profile-app-modal-title">{currentContent.title}</h2>
          <button className="profile-app-modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <div className="profile-app-modal-content">
          <div className="profile-app-modal-icon">
            <FontAwesomeIcon icon={faMobile} size="3x" />
          </div>
          
          <p className="profile-app-modal-message">
            {currentContent.message}
          </p>
          
          <button className="profile-app-modal-cta" onClick={handleOpenApp}>
            Open App
          </button>
          
          <p className="profile-app-modal-note">
            Don't have the app? Tap "Open App" to download from the App Store.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileAppModal;
